<template>
  <div>
    <template v-for="(p, n) in source">
      <div class="message is-warning" :key="n">
        <h4 class="message-header">Page {{ n + 1 }}</h4>
        <div class="message-body">
          <div
            class="columns is-variable bd-klmn-columns is-1"
            v-for="(c, index) in p"
            :key="index"
          >
            <div class="column is-2" v-for="d in c" :key="d._id">
              <component :is="card" :data="d" :image_click="showImageModal" />
            </div>
          </div>
        </div>
      </div>
    </template>
    <div class="columns is-variable bd-klmn-columns is-1">
      <div class="column" style="text-align: center;">
        <article class="message is-medium" v-if="next == null">
          <div class="message-header">
            <p>No More</p>
          </div>
        </article>
        <progress v-else class="progress is-small is-primary" max="100"
          >15%</progress
        >
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { setupCache } from "axios-cache-adapter";
import qs from "qs";

const cache = setupCache({
  maxAge: 30 * 60 * 1000,
  exclude: {
    query: false,
  },
});

const api = axios.create({ adapter: cache.adapter });

export default {
  name: "FlowBoard",
  props: {
    flowSource: { type: String, required: true },
    card: { type: Object, required: true },
    query: { type: Object, required: true },
    weight: { type: Number, default: 6 },
  },
  data() {
    return {
      next: this.flowSource,
      source: [],
      count: 0,
      display: 0,
      onLoad: false,
    };
  },
  mounted: function() {
    this.getSource();
  },
  watch: {
    query: {
      deep: true,
      handler() {
        if (!this.$parent._inactive) {
          this.source = [];
          this.display = 0;
          this.count = 0;
          this.next = this.flowSource;
          this.getSource();
        }
      },
    },
    display: function() {
      this.freshTitle();
    },
  },
  activated: function() {
    const otherOnscrollFn = document.onscroll
      ? document.onscroll
      : function() {};
    document.onscroll = () => {
      otherOnscrollFn();
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      const clientHeight = document.documentElement.clientHeight;
      const scrollHeight = document.documentElement.scrollHeight;
      if (
        !this.onLoad &&
        scrollHeight - scrollTop - clientHeight <= 10 &&
        this.next != null
      ) {
        this.getSource();
      }
    };
  },
  deactivated: function() {
    document.onscroll = () => {};
  },
  methods: {
    freshTitle() {
      document.title = `Load ${this.display} of ${this.count}`;
    },
    getSource() {
      this.onLoad = true;
      let params = {};
      if (this.next == this.flowSource) {
        params = this.query;
      }
      api({
        method: "get",
        url: this.next,
        params: params,
        paramsSerializer: (params) => {
          return qs.stringify(params, { arrayFormat: "repeat" });
        },
        headers: {
          Authorization: "Token " + localStorage.getItem("token"),
        },
      }).then((res) => {
        let current = [];
        for (let i = 0; i < res.data.results.length / this.weight; i++) {
          let l = [];
          for (let j = 0; j < this.weight; j++) {
            const index = i * this.weight + j;
            if (index < res.data.results.length) {
              this.display++;
              l.push(res.data.results[index]);
            }
          }
          current.push(l);
        }
        this.source.push(current);
        this.count = res.data.count;
        this.next = res.data.next;
        this.onLoad = false;
      });
    },
    showImageModal() {},
  },
};
</script>

<style scoped></style>
